export default "__VITE_ASSET__PyAXD$6MrK08Wwes5WOf9g__";